import { Badge } from '@/components/ui/badge';

const statusConfig: Record<string, { label: string; className: string }> = {
  PROSPECTO: { label: 'Prospecto', className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300' },
  ATIVO: { label: 'Ativo', className: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300' },
  INATIVO: { label: 'Inativo', className: 'bg-gray-100 text-gray-500 dark:bg-gray-800/40 dark:text-gray-400' },
};

export function ClienteStatusBadge({ status }: { status: string }) {
  const cfg = statusConfig[status] ?? { label: status, className: '' };
  return <Badge variant="outline" className={cfg.className}>{cfg.label}</Badge>;
}
